import Vue from 'vue'
import { mapState } from 'vuex'
import { sync } from 'vuex-router-sync'
import VueSVGIcon from 'vue-svgicon'
import VueI18n from 'vue-i18n'
import Notifications from 'vue-notification'
import VCalendar from 'v-calendar'
import { USER_MODULE_NAME } from '@/store/types'
import views from '@/components'
import App from './App/'
import router from './router'
import store from './store/'
import i18n from './i18n/'
import './assets/icons'
import FNOLFlow from './fnol'
import * as Settings from '@/infra/settings'
import { getUser } from '@/services/API/authentication'
// import * as Sentry from '@sentry/vue'
// import { Integrations } from '@sentry/tracing'
// import './filters.js'

sync(store, router)

Vue.config.productionTip = false

Vue.use(VueSVGIcon)
Vue.use(VueI18n)
Vue.use(Notifications)
Vue.use(VCalendar)

const routesComponents = function(routes) {
  routes.forEach(route => {
    routeComponent(route)
  })
}

const routeComponent = function(route) {
  route.component = views[route.component]
  if (route.children && route.children.length > 0) {
    routesComponents(route.children)
  }
}

const initApp = function() {
  if (FNOLFlow.isExecuting) {
    return
  }

  const mavAuth = Settings.getTokenStorage()
  let mavRole = localStorage.getItem('mavRole')
  var host = window.location.host
  var subdomain = host.split('.')[1]
  var maDomain = true
  if (subdomain === 'allianz') {
    maDomain = false
  }
  Vue.prototype.$maDomain = maDomain

  /**
   * avoid conflict between having FNOL role loaded before and not executing
   */
  if (mavRole === 'FNOL') {
    localStorage.removeItem('mavRole')
    mavRole = undefined
  }

  let mavRoutes
  // Get data from user endpoint not localStorage
  try {
    mavRoutes = JSON.parse(localStorage.getItem('mavRoutes'))
  } catch (e) {}

  if (
    mavAuth &&
    mavAuth.length > 0 &&
    mavRole &&
    mavRole.length > 0 &&
    mavRoutes
  ) {
    store.dispatch('user/USER_UPDATE_ROUTES', mavRoutes)
    store.commit('user/USER_SET_ROLE', mavRole)
    getUser().then(user => {
      store.commit('user/USER_UPDATE_IS_COMPANYADMIN', user.is_company_admin)
      store.commit('user/USER_UPDATE_IS_SUPERADMIN', user.is_superadmin)
      store.commit('user/USER_UPDATE_IS_SELFCAREADMIN', user.is_selfcare_admin)
    })
    routesComponents(mavRoutes)
    router.addRoutes(mavRoutes)
  } else {
    localStorage.removeItem('mavAuth')
    localStorage.removeItem('mavRole')
    localStorage.removeItem('mavRoutes')
    localStorage.removeItem('mavAdmin')
    sessionStorage.removeItem('authCognito')
  }

  // Setting the actual view from localStorage
  if (localStorage.getItem('maAgentView') !== null) {
    store.dispatch(
      'UPDATE_VIEW',
      JSON.parse(localStorage.getItem('maAgentView'))
    )
  }
}

Vue.mixin({
  data() {
    return {
      FNOLFlow
    }
  },
  computed: {
    ...mapState(USER_MODULE_NAME, {
      stateUserIsCompanyAdmin: 'isCompanyAdmin' || false,
      stateUserIsSuperAdmin: 'isSuperAdmin' || false,
      stateUserIsSelfcareAdmin: 'isSelfcareAdmin' || false,
      stateUserIsReduxMode: 'isReduxMode' || false,
      stateUserIsMixEnable: 'isMixEnabled' || false
    })
  },
  methods: {
    throwNotification: function(title, text, type = 'OK') {
      const icon = type.toLowerCase()
      this.$notify({
        group: 'main',
        data: { title, text, icon },
        duration: 2000
      })
    }
  }
})

Vue.filter('floatToFixed', function(value, decimals) {
  if (Math.round(value) !== value) {
    return value.toFixed(decimals)
  }
  return value
})

Vue.filter('textOverflow', function(value, length) {
  return value.length > length ? `${value.substr(0, length)}...` : value
})

Vue.config.errorHandler = function(err, vm, info) {
  if (process.env.NODE_ENV === 'dev') {
    console.debug('err', err, vm, info)
  }
}

initApp()

// const PRE = 'premavalue.plataforma-smart.com'
// const PRO = 'mavalue.plataforma-smart.com'

// Sentry.init({
//   Vue,
//   dsn: 'https://b0f7628c436645dd89320a04ab45797a@o912381.ingest.sentry.io/5905107',
//   integrations: [
//     new Integrations.BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracingOrigins: [PRE, PRO, /^\//]
//     })
//   ],
//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
//   allowUrls: [PRE, PRO, /^\//]
// })

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
